export default __webpack_public_path__ + "static/media/exchange.9bb9b016.png";